import * as types from "../../constants";
import { getService } from "../../services/stateService";

export function get(country) {
  return async (dispatch) => {
    dispatch({ type: types.STATES_SELECT_PENDING });
    return getService(country)
      .then((response) => {
        dispatch({
          type: types.STATES_SELECT_IN_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.STATES_SELECT_IN_FAILURE, error });
        throw error;
      });
  };
}
